// import qs from 'qs'
import request from '@/utils/request'
// api

// 首页接口
export function indexList(params) {
  return request({
    url: '/api/index/list',
    method: 'get',
    params
  })
}
// 基本信息接口
export function infoList(params) {
  return request({
    url: '/api/info/list',
    method: 'get',
    params
  })
}
//菜单接口
export function menuList(params) {
  return request({
    url: '/api/menu/list',
    method: 'get',
    params
  })
}

/**文章接口 */
//文章详情 通过文章ID查询数据
export function articleDetail(params) {
  return request({
    url: '/api/article/detail',
    method: 'get',
    params
  })
}
//文章列表 通过文章分类(菜单ID)查询列表
export function articleList(params) {
  return request({
    url: '/api/article/list',
    method: 'post',
    data: params
  })
}

/**广告详情 */
//广告详情 通过广告ID查询数据
export function advertisingDetail(params) {
  return request({
    url: '/api/advertising/detail',
    method: 'get',
    params
  })
}
//查询广告列表信息
export function advertisingList(params) {
  return request({
    url: '/api/advertising/list',
    method: 'get',
    params
  })
}
//查询部门下所有轮播图
export function advertisingSlideshow(params) {
  return request({
    url: '/api/advertising/slideshow',
    method: 'get',
    params
  })
}
